/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ServiceLevelChangeRequestDirection } from './';
import {
    ServiceLevelChangeRequestDirectionFromJSON,
    ServiceLevelChangeRequestDirectionFromJSONTyped,
    ServiceLevelChangeRequestDirectionToJSON,
} from './';
import type { ServiceLevelType } from './';
import {
    ServiceLevelTypeFromJSON,
    ServiceLevelTypeFromJSONTyped,
    ServiceLevelTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ServiceLevelStatusResourcePendingRequest
 */
export interface ServiceLevelStatusResourcePendingRequest {
    /**
     * 
     * @type {ServiceLevelChangeRequestDirection}
     * @memberof ServiceLevelStatusResourcePendingRequest
     */
    direction: ServiceLevelChangeRequestDirection;
    /**
     * 
     * @type {ServiceLevelType}
     * @memberof ServiceLevelStatusResourcePendingRequest
     */
    requestedServiceLevel: ServiceLevelType;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelStatusResourcePendingRequest
     */
    authorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelStatusResourcePendingRequest
     */
    reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceLevelStatusResourcePendingRequest
     */
    date: Date;
}

/**
 * Check if a given object implements the ServiceLevelStatusResourcePendingRequest interface.
 */
export function instanceOfServiceLevelStatusResourcePendingRequest(value: object): value is ServiceLevelStatusResourcePendingRequest {
    if (!('direction' in value) || value['direction'] === undefined) return false;
    if (!('requestedServiceLevel' in value) || value['requestedServiceLevel'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    return true;
}

export function ServiceLevelStatusResourcePendingRequestFromJSON(json: any): ServiceLevelStatusResourcePendingRequest {
    return ServiceLevelStatusResourcePendingRequestFromJSONTyped(json, false);
}

export function ServiceLevelStatusResourcePendingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLevelStatusResourcePendingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'direction': ServiceLevelChangeRequestDirectionFromJSON(json['direction']),
        'requestedServiceLevel': ServiceLevelTypeFromJSON(json['requestedServiceLevel']),
        'authorFullName': json['authorFullName'] == null ? undefined : json['authorFullName'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'date': (new Date(json['date'])),
    };
}

export function ServiceLevelStatusResourcePendingRequestToJSON(value?: ServiceLevelStatusResourcePendingRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'direction': ServiceLevelChangeRequestDirectionToJSON(value['direction']),
        'requestedServiceLevel': ServiceLevelTypeToJSON(value['requestedServiceLevel']),
        'authorFullName': value['authorFullName'],
        'reason': value['reason'],
        'date': ((value['date']).toISOString()),
    };
}

